<template>
    <section id="service">
        <div class="service-content">
            <div class="content">
                <h2 class="title">{{$t('confSection.title')}}</h2>
                <p class="text">
                    {{$t('confSection.text1')}}
                </p>
                <p class="text">
                    {{$t('confSection.text2')}}
                </p>
                <div class="learn-more">
                  <a :href="$t('confSection.moreBtnLink')">
<!--                  <a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]+ '?room-type=17704'" class="orange-btn">{{$t('booking.title')}}</a>-->
                    <button class="learn-btn"> {{$t('confSection.moreBtn')}}</button>
                    <a href="tel:+0487744473" class="phone binct-phone-number-3">+38 (048) 774 44 73</a>
                  </a>
<!--                    <a href="#modal_service" class="open-modal" id="conference-button">-->
<!--                        <button class="learn-btn"> {{$t('confSection.moreBtn')}}</button></a>-->
<!--                    <a href="tel:+0487744473" class="phone binct-phone-number-3">+38 (048) 774 44 73</a>-->
                </div>
            </div>
        </div>
        <div class="service-images">
        <div class="slick-carousel">
          <div>
            <img src="/img/conference/conference1.png" alt="">
          </div>
          <div>
            <img src="/img/conference/conference2.png" alt="">
          </div>
          <div>
            <img src="/img/conference/conference3.png" alt="">
          </div>
          <div>
            <img src="/img/conference/conference4.png" alt="">
          </div>
          <div>
            <img src="/img/conference/conference5.png" alt="">
          </div>
          <div>
            <img src="/img/conference/conference6.png" alt="">
          </div>
          <div>
            <img src="/img/conference/conference7.png" alt="">
          </div>
          <div>
            <img src="/img/conference/conference8.png" alt="">
          </div>
        </div>

        <div class="m-slider">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img data-src="/img/conference/conference1.png" class="swiper-lazy" alt="">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>
              <div class="swiper-slide">
                <img data-src="/img/conference/conference2.png" class="swiper-lazy" alt="">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>
              <div class="swiper-slide">
                <img data-src="/img/conference/conference3.png" class="swiper-lazy" alt="">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>
              <div class="swiper-slide">
                <img data-src="/img/conference/conference4.png" class="swiper-lazy" alt="">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>
              <div class="swiper-slide">
                <img data-src="/img/conference/conference5.png" class="swiper-lazy" alt="">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>
              <div class="swiper-slide">
                <img data-src="/img/conference/conference6.png" class="swiper-lazy" alt="">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>
              <div class="swiper-slide">
                <img data-src="/img/conference/conference7.png" class="swiper-lazy" alt="">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>
              <div class="swiper-slide">
                <img data-src="/img/conference/conference8.png" class="swiper-lazy" alt="">
                <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </div>

            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination swiper-pagination-white"></div>
          </div>
        </div>
        <!--            <div class="image-1"></div>-->
        <!--            <div class="image-2" style="background: url(./img/service-2.jpg) 100% 0 / cover no-repeat"></div>-->
      </div>
    </section>
</template>

<script>
    export default {
        name:'Service'
    }
</script>
